import {Component, ViewEncapsulation} from '@angular/core'
import {ResolveEnd, Router} from "@angular/router";

@Component({
  selector: 'app-root',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})


export class AppComponent {
  hideContent: boolean = false;
  hidePadding: boolean = false;

  constructor(private router: Router) {
    //console.log('router url:' + router.url);

    router.events.filter((event) => event instanceof ResolveEnd)
      .subscribe((event) => {
        var path = event['url'];
        var chatPath = "/signin";
        if (path.indexOf(chatPath) != -1) {
          this.hidePadding = true;
        } else {
          this.hidePadding = false;
        }
      });

    //console.log('router url:' + router.url);

    if (router.url === '#/authen/signin') {
      this.hideContent = true;
    } else {
      this.hideContent = false;
    }
  }

  title = 'app';
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts